import { useState, useMemo } from 'react';

const sortByBultosMarcaSku = (sortConfig, a, b) => {
  if (typeof(a['items']) === 'object' && typeof(b['items']) === 'object') {
    if (a['items'].length < b['items'].length) {
      return sortConfig.direction === 'ascending' ? -1 : 1;
    }
    else if (a['items'].length > b['items'].length) {
      return sortConfig.direction === 'ascending' ? 1 : -1;
    }
    else {
      const marcaA = a['brand'] ? a['brand'] : '';
      const marcaB = b['brand'] ? b['brand'] : '';
      //console.log("marcaA:", marcaA, ", marcaB:", marcaB);

      if (marcaA < marcaB) {
        return sortConfig.direction === 'ascending' ? -1 : 1;
      }
      else if (marcaA > marcaB) {
        return sortConfig.direction === 'ascending' ? 1 : -1;
      }
      else {
        const skuA = a['items'][0] && a['items'][0].variant && a['items'][0].variant.sku 
          ? a['items'][0].variant.sku 
          : '';

        const skuB = b['items'][0] && b['items'][0].variant && b['items'][0].variant.sku
          ? b['items'][0].variant.sku 
          : '';
        //console.log("skuA:", skuA, ", skuB:", skuB);

        if (skuA < skuB) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        else if (skuA > skuB) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        else {
          return 0;
        }
      }
    }
  }
  else {
    return 0;
  }
}

const parseCode = (str) => {
  // formato: <numero>P<letras><numero> con '+' opcional al final
  const match = str.match(/^(\d+)P([A-Za-z]+)(\d+)(\+)?$/);

  if (!match) {
    // Fallback seguro: manda al final en comparaciones numéricas
    return {
      prefixNum: Number.MAX_SAFE_INTEGER,
      middle: String(str ?? ""),
      suffixNum: Number.MAX_SAFE_INTEGER,
      hasPlus: false
    };
  }

  return {
    prefixNum: parseInt(match[1], 10),
    middle: match[2],
    suffixNum: parseInt(match[3], 10),
    hasPlus: !!match[4]
  };
}

const sortByLocation = (sortConfig, a, b) => {
  if (a['location'] === "-" && b['location'] === "-") return 0;
  if (a['location'] === "-") return sortConfig.direction === 'ascending' ? 1 : -1;
  if (b['location'] === "-") return sortConfig.direction === 'ascending' ? -1 : 1;

  const direction = sortConfig?.direction === "ascending" ? 1 : -1;

  const pa = parseCode(a['location']);
  const pb = parseCode(b['location']);

  // 1) número antes de la P
  if (pa.prefixNum !== pb.prefixNum) {
    return (pa.prefixNum - pb.prefixNum) * direction;
  }

  // 2) letras después de la P (case-insensitive)
  const midA = pa.middle.toLowerCase();
  const midB = pb.middle.toLowerCase();
  if (midA !== midB) {
    return midA.localeCompare(midB) * direction;
  }

  // 3) número al final
  if (pa.suffixNum !== pb.suffixNum) {
    return (pa.suffixNum - pb.suffixNum) * direction;
  }

  // 4) TIE-BREAK: dentro del mismo número final,
  //    primero sin '+', luego con '+', SIEMPRE (no depende de direction)
  if (pa.hasPlus !== pb.hasPlus) {
    return pa.hasPlus ? 1 : -1; // sin '+' (false) antes que con '+' (true)
  }

  return 0;
};

const useSortableData = (items, config = null) => {
    const [sortConfig, setSortConfig] = useState(config);
    
    const sortedItems = useMemo(() => {
      let sortableItems = items ? [...items] : [];
      if (sortConfig !== null) {
        sortableItems.sort((a, b) => {
          const key = sortConfig.key;
          if (key === 'items') {
            return sortByBultosMarcaSku(sortConfig, a, b);
          }
          else if (key === 'location') {
            return sortByLocation(sortConfig, a, b);
          }
          else {
            if (a[key] < b[key]) {
              return sortConfig.direction === 'ascending' ? -1 : 1;
            }
            if (a[key] > b[key]) {
              return sortConfig.direction === 'ascending' ? 1 : -1;
            }
          }
          return 0;
        });
      }

      sortableItems = sortableItems.map((item, index) => ({
        ...item,
        sortedIndex: index,
      }));

      return sortableItems;
    }, [items, sortConfig]);
  
    const requestSort = key => {
      let direction = 'ascending';
      if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
        direction = 'descending';
      }
      setSortConfig({ key, direction });
    }

    return { items: sortedItems, requestSort, sortConfig };
}

export default useSortableData;